module.exports = __webpack_public_path__ + "img/left-leg.53a2faa9.png";